import type { ActionSource } from 'owa-analytics-types';
import { lazyOnFlagUnflag } from 'owa-mail-commands-actions';
import type { ClientItemId } from 'owa-client-ids';
import type FlagType from 'owa-service/lib/contract/FlagType';

export function onFlagUnflag(
    actionSource: ActionSource,
    flagType?: FlagType,
    override?: boolean,
    itemId?: ClientItemId
): void {
    lazyOnFlagUnflag.importAndExecute(actionSource, flagType, override, itemId);
}
